import {Inject, Injectable} from '@angular/core';
import {merge, Observable} from 'rxjs';
import {share, takeUntil} from 'rxjs/operators';
import {destroy$} from '../../destroyable';
import {SubscriptionStreamingService, SubscriptionSubject} from '../../streaming/subscription-streaming.service';
import {SubscriptionSubjectType} from '../../streaming/subscription-subject-type';
import {DEX_STREAMING_SUBJECTS_INJECTION_TOKEN, DexStreamingSubjectService} from './subjects/dex-subjects-injection';
import {createDexTempSubject} from './subjects/dex-temp-subjects';

@Injectable()
export class DexStreamingService {

    public readonly destroy$ = destroy$();

    public readonly stream$: Observable<unknown>;

    constructor(
        private subscriptionStreamingService: SubscriptionStreamingService,

        @Inject(DEX_STREAMING_SUBJECTS_INJECTION_TOKEN)
        private subjectServices: DexStreamingSubjectService[]
    ) {
        // TODO
        (window as any).dexStreamingSrv = this;
        (window as any).createDexTempSubject = createDexTempSubject;
        (window as any).dexStreamingTest = (sub: string, cb?: (m: any) => void) => {
            this.createSubscription(
                createDexTempSubject(sub)
            ).subscribe(cb);
        };

        this.stream$ = this.createSharedStream();
    }

    public createSubscription<T>(type: SubscriptionSubjectType<T>, subject?: SubscriptionSubject): Observable<T> {
        return this.subscriptionStreamingService.createSubscription(type, subject);
    }

    public use(consumerDestroy$: Observable<unknown>): void {
        this.stream$.pipe(
            takeUntil(consumerDestroy$)
        ).subscribe();
    }

    private createSharedStream(): Observable<unknown> {
        const subs = this.subjectServices.map(subjectService =>
            this.createSubscription(subjectService.type)
        );

        return merge(...subs).pipe(
            takeUntil(this.destroy$),
            share()
        );
    }

}
